import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromActions from './device.actions';
import { map, switchMap } from 'rxjs/operators';
import { Device, DeviceInfo } from '@capacitor/device';

@Injectable()
export class DeviceEffects {
  getDeviceInfo: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(fromActions.InitDeviceInfo),
      switchMap((action: any) =>
        from(Device.getInfo()).pipe(
          map((result: DeviceInfo) => {
            if (result) {
              return fromActions.InitDeviceInfoSuccess({
                deviceInfo: result,
              });
            } else {
              return fromActions.InitDeviceInfoError({});
            }
          })
        )
      )
    )
  );

  constructor(private actions: Actions) {}
}
